<template>
  <div v-loading="loading">
    <div class="spu-title">
      <custom-breadcrumb/>
    </div>
    <div>
      <el-form :model="form">

        <el-form-item label="Brand SPU ID" :required="true">
          <el-input v-model="form['productId']" maxlength="16" show-word-limit onkeyup="value=value.replace(/[^a-zA-Z0-9-]/g,'');if(value&&value.length>17)value=value.substring(0,16)"></el-input>
          <div class="required-form-error" v-show="!form.productId">Product Id can't be blank</div>
          <div class="required-form-error" v-show="form.productId && productIdRepeat ">Duplicate SPU ID, please modify</div>
        </el-form-item>

        <el-form-item label="Title" :required="true">
          <el-input v-model="form.title" maxlength="120" show-word-limit></el-input>
          <div class="required-form-error" v-show="!form.title">Product title can't be blank</div>
        </el-form-item>

        <el-form-item label="Category" :required="true">
          <br>
          <el-select v-model="form.cateId" @change="changeCate" filterable placeholder="Please Select Category" style="width:40%">
            <el-option
              v-for="item in categoryList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="required-form-error" v-show="!form.cateId">Product Category can't be blank</div>
          <div class="required-form-error" v-show="form.cateId && form.categoryIsOutOfStock">
            This product category has been removed, the website cannot display this product, please update the category
          </div>

        </el-form-item>

        <el-form-item label="Brand"  :required="true" style="display: flex;flex-direction: column;">
          <el-select
            v-model="form['collectionBrandId']"
            clearable
            placeholder="Please select Brand"
            remote
            filterable
            reserve-keyword
            :remote-method="loadBrands"
            @change="changBrand"
            style="width:40%"
          >
            <el-option
              v-for="item in brandOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="required-form-error cust-form-item-spu" v-show="!form.collectionBrandId">Please select Brand</div>

        </el-form-item>

        <el-form-item label="Shipping from country" :required="true" style="display: flex;flex-direction: column;">
          <el-radio-group v-model="form.shippingCountryCode" name="shippingCountryCode" class="cust-form-item-spu" @input="changeShippingCountry">
            <el-radio :label="1" >China</el-radio>
            <el-radio :label="2" >USA</el-radio>
          </el-radio-group>
          <div class="required-form-error cust-form-item-spu" v-show="!form.shippingCountryCode">Please select a shipping country</div>
          <div class="required-error" style="margin-top: 2px;"
               v-if="form['reviewContentList'] && form['reviewContentList'].filter(f=>f['reviewContent']=='shipping_country_code').length>0">
            modify is {{form['reviewContentList'].filter(f=>f['reviewContent']=='shipping_country_code') | disUpdateAfterValueShippingcode}}, under review
          </div>
        </el-form-item>

        <el-form-item label="Shipping Fee" style="display: flex;flex-direction: column;">
          <el-radio-group v-model="form.isFreeShipping" disabled class="cust-form-item-spu">
            <el-radio :label="true">Shipping Fee</el-radio>
            <el-radio :label="false">Non free</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Description" :required="true">
          <!-- <div id="editor" ref="editor"></div> -->
          <QuillEditor style="margin-top:40px" @resultDesciption="resultDesciption"/>
          <div class="required-form-error" v-show="!descInfo">Product description can't be blank</div>

        </el-form-item>
        <el-form-item>
          <div slot="label">
            <p class="is-required"><span style="color: #F56C6C;">*</span>&nbsp;Product Photos</p>
            <p class="sub-title">Product images showcase your product clearly and usually shot on a white background.
              (Ideal Size: Square - 800 x 800 or higher,up to 30 sheets supported)</p>
          </div>

        </el-form-item>

        <div class="pro-photo">
          <el-upload
            :action="uploadApi"
            ref="upload"
            list-type="picture-card"
            accept=".jpeg,.png,.jpg"
            multiple
            :limit="30"
            :on-preview="handlePictureCardPreview"
            :file-list.sync="spuFilelist"
            :on-remove="handleRemove"
            :http-request="uploadRequest"
            :on-success="handleSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="required-form-error" v-show="!spuFilelist || spuFilelist.length<1">Product photos can't be blank
          </div>
        </div>

      </el-form>
      <div>
        <div class="variant">
          <div class="variant-title">
            <p>Variant</p>
            <p class="sub-title">Add variants to your product if it comes in more than one option such as size or
              color.</p>
          </div>
          <div class="variant-sub-title">
            <div>{{totalSkuCount}} Variant</div>
            <div @click="showVariant">Add Variant</div>
          </div>
          <div>
            <el-table
              ref="table"
              :data="table"
              :key="tableKey"
              stripe
            >

              <!-- 临时列，避免动态添加列和行后横向自动滚动 -->
              <el-table-column label="id" width="5" v-show="false" fixed >
                <template slot-scope="scope">
                </template>
              </el-table-column>

              <template v-for="(item,key) in tableColumn">

                <el-table-column v-if="item=='Image'" :key="key" :label="item" width="100" fixed>
                  <template slot-scope="scope">
                    <div v-if="item=='Image'" class="tableImage">
                      <el-upload
                        :action="uploadApi"
                        :disabled="scope['row']['isDeleted']"
                        class="avatar-uploader"
                        list-type="picture-card"
                        accept=".jpeg,.png,.jpg"
                        :file-list="skuFileList[scope.$index]"
                        :key="key"
                        :limit="1"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="(file, fileList)=>handleSkuRemove(file,fileList,scope.$index)"
                        :on-success="(response, file, fileList)=>handleSkuSuccess(response,file,fileList,scope.$index)">
                        <img v-if="scope['row'][item]" :src="scope['row'][item]" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Brand SKU ID'" :key="key" :label="item" width="200" >
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input v-model="scope['row'][item]" ref="inputRef" @keydown.native="clickBrandSkuCode($event)" @input="(event)=>changeBrandSkuCode(event,scope['row'])"  :disabled="scope['row']['isDeleted']"></el-input>
                    </div>
                    <template v-if="!scope['row']['isDeleted']">
                      <div class="required-error" v-show="!scope['row'][item]">Brand SKU ID can't be blank</div>
                      <div class="required-error" v-if="scope['row'][item] && scope['row']['isRepeatBrandSku']">Duplicate SKU ID, please modify</div>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Case'" :key="key" :label="item" width="80" >
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Case
                      <i class="el-icon-edit" @click="skuSetDiglog('Case')" data-key="Case"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input
                        :disabled="scope['row']['isDeleted']"
                        oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value<=0){value=1} if(value>100){value=100}"
                        :maxlength="3" :minlength="1" v-model="scope['row'][item]"></el-input>
                      <sku-bluk-set field="Case" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Case'"></sku-bluk-set>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='FOB Price($)'" :key="key" :label="item" width="180"
                                 class="cust-table-column">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      FOB Price($)
                      <!-- <i class="el-icon-edit" @click="skuSetDiglog('FOB Price')" data-key="FOB Price"></i> -->
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <div>{{ scope['row'][item] }}</div>
                      <!-- <el-input style="width: 70px" @input="(event)=>blurFob(event,scope.$index,scope['row'])"  :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                v-model="scope['row'][item]">
                      </el-input> -->
                      <template v-if="!scope['row']['isDeleted']">
                        <!-- <div class="required-error" v-show="!scope['row'][item]">FOB Price can’t be blank</div> -->
                        <div class="required-error" style="margin-top: 13px;"
                             v-if="scope['row']['svGoodsReviewLogList'] && (scope['row']['svGoodsReviewLogList'].filter(f=>f['reviewContent']=='fob_price').length>0)">
                          modify is {{ scope['row']['svGoodsReviewLogList'] | disUpdateAfterValue('fob_price') }}, under
                          review
                        </div>
                      </template>

                      <!-- <sku-bluk-set field="FOB Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'FOB Price'"></sku-bluk-set> -->

                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Cost Price($)'" :key="key" :label="item" width="180"
                                 class="cust-table-column">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Cost Price($)
                      <i class="el-icon-edit" @click="skuSetDiglog('Cost Price')" data-key="Cost Price"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 70px" @blur="(event)=>blurCostPriceFob(event,scope.$index,scope['row'])"
                                  :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                v-model="scope['row'][item]">
                      </el-input>
                      <template v-if="!scope['row']['isDeleted']">
                        <div class="required-error" v-show="!scope['row'][item]">Cost Price can’t be blank</div>
                        <div class="required-error" style="margin-top: 13px;"
                             v-if="scope['row']['svGoodsReviewLogList'] && (scope['row']['svGoodsReviewLogList'].filter(f=>f['reviewContent']=='source_price').length>0)">
                          modify is {{ scope['row']['svGoodsReviewLogList'] | disUpdateAfterValue('source_price') }},
                          under review
                        </div>
                      </template>
                      <sku-bluk-set field="Cost Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Cost Price'"></sku-bluk-set>

                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-else-if="item==='Wholesale Price($)'" width="180" :key="key" :label="item">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Wholesale Price($)
                      <i class="el-icon-edit" @click="skuSetDiglog('Wholesale Price')" data-key="Wholesale Price"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <!-- <div>{{ scope['row'][item] }}</div> -->
                      <el-input style="width: 70px" @blur="(event)=>blurCif(event,scope.$index,scope['row'])"  :disabled="scope['row']['isDeleted'] || disableFormFlag"
                                  oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                  v-model="scope['row'][item]">
                        </el-input>
                      <template v-if="!scope['row']['isDeleted']">
                        <div class="required-error" v-show="!scope['row'][item]">Wholesale Price can’t be blank</div>
                        <div class="required-error" style="margin-top: 22px;"
                            v-if="scope['row']['svGoodsReviewLogList'] && (scope['row']['svGoodsReviewLogList'].filter(f=>f['reviewContent']=='cif_price').length>0)">
                          modify is {{ scope['row']['svGoodsReviewLogList'] | disUpdateAfterValue('cif_price') }}, under
                          review
                        </div>
                      </template>
                      <sku-bluk-set field="Wholesale Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Wholesale Price'"></sku-bluk-set>
                    </div>
                  </template>
                </el-table-column>

<!--                <el-table-column v-else-if="item=='Procurement Price($)'"   :key="key" :label="item" width="200"-->
<!--                                 class="cust-table-column">-->
<!--                  <template slot="header" slot-scope="scope">-->
<!--                    <div class="cust-title">-->
<!--                      Procurement Price($)-->
<!--                      <i class="el-icon-edit" @click="skuSetDiglog('Procurement Price')" data-key="Procurement Price"></i>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                  <template slot-scope="scope">-->
<!--                    <div class="table-cell-input">-->
<!--                      <el-input style="width: 70px"-->
<!--                                :disabled="scope['row']['isDeleted']"-->
<!--                                oninput="-->
<!--                                if(value){value=value.replace(/[^0-9.]/g,'')}-->
<!--                                if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}-->
<!--                                "-->
<!--                                @change="(val) => {scope['row'][item] = val || 0}"-->
<!--                                v-model="scope['row'][item]">-->
<!--                      </el-input>-->
<!--                      <sku-bluk-set field="Procurement Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Procurement Price'"></sku-bluk-set>-->

<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->

                <el-table-column v-else-if="item=='Wholesale Settlement Price($)'" :key="key" :label="item" width="250"
                                 class="cust-table-column">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Wholesale Settlement Price($)
                      <i class="el-icon-edit" @click="skuSetDiglog('Wholesale Settlement Price')" data-key="Wholesale Settlement Price"></i>

                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 70px"
                                oninput="
                                if(value){value=value.replace(/[^0-9.]/g,'')}
                                if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                @change="(val) => {scope['row'][item] = val || 0}"
                                :disabled="scope['row']['isDeleted']"
                                v-model="scope['row'][item]">
                      </el-input>
                      <sku-bluk-set field="Wholesale Settlement Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Wholesale Settlement Price'"></sku-bluk-set>

                    </div>
                  </template>
                </el-table-column>

                <el-table-column v-else-if="item==='Retail Price($)'" width="200" :key="key" :label="item">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Retail Price($)
                      <i class="el-icon-edit"  @click="skuSetDiglog('Retail Price')" data-key="Retail Price"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <!--                   <div >{{scope['row'][item]}}</div>
                                       <div class="required-error" style="margin-top: 22px;" v-if="scope['row']['svGoodsReviewLogList'] && (scope['row']['svGoodsReviewLogList'].filter(f=>f['reviewContent']=='retail_price').length>0)">
                                         modify is {{ scope['row']['svGoodsReviewLogList'] | disUpdateAfterValue('retail_price') }}, under review
                                       </div>-->
                    <div class="table-cell-input">
                      <el-input style="width: 70px"
                                @change="(event)=>blurRetailPriceFob(event,scope.$index,scope['row'])"
                                :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                                v-model="scope['row'][item]">
                      </el-input>
                      <template v-if="!scope['row']['isDeleted']">
                        <div class="required-error" style="margin-top: 13px;"
                             v-show="Number(scope['row']['Wholesale Price($)'])>0 && ( (Number(scope['row']['Retail Price($)'])-Number(scope['row']['Wholesale Price($)']))/Number(scope['row']['Retail Price($)']) ) <=0.3  ">
<!--                          Must Retail price >-->
<!--                          （建议零售价-批发价）/建议零售价>30%-->
                          Ensure >30% margin vs. wholesale price.
                        </div>
                      </template>

                      <sku-bluk-set field="Retail Price" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Retail Price'"></sku-bluk-set>

                    </div>

                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Weight(g)'" :key="key" :label="item" width="110">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Weight(g)
                      <i class="el-icon-edit" @click="skuSetDiglog('Weight')" data-key="Weight"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input @change="(event)=>blurWeight(event,scope.$index,scope['row'])"  :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>10000){value=10000}"
                                v-model="scope['row'][item]"></el-input>
                    </div>
                    <template v-if="!scope['row']['isDeleted']">
                      <div class="required-error" v-show="!scope['row'][item]">Can't be blank</div>
                      <div class="required-error" style="margin-top: 13px;"
                           v-if="scope['row']['svGoodsReviewLogList'] && (scope['row']['svGoodsReviewLogList'].filter(f=>f['reviewContent']=='weight').length>0)">
                        modify is {{
                          scope['row']['svGoodsReviewLogList'] | disUpdateAfterValueObj('weight') | disUpdateAfterValueWeight
                        }}, under review
                      </div>
                    </template>
                    <sku-bluk-set field="Weight" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Weight'"></sku-bluk-set>

                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='Inventory'" :key="key" :label="item" width="190">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Inventory
                      <i class="el-icon-edit" @click="skuSetDiglog('Inventory')" data-key="Inventory"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input :maxlength="5" :minlength="1"
                                style="width: 100px"
                                :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/[^\d]/g,'')}  if(value>10000){value=10000}"
                                v-model="scope['row'][item]"></el-input>
                      <!-- <el-button type="text" style="margin-left: 4px" @click="handleInventory(scope.row.id)">
                        View
                      </el-button> -->
                    </div>
                    <template v-if="!scope['row']['isDeleted']">
                      <div class="required-error" v-show="!scope['row'][item]">Can't be blank</div>
                    </template>
                    <sku-bluk-set field="Inventory" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Inventory'"></sku-bluk-set>

                  </template>
                </el-table-column>
                <el-table-column v-else-if="item=='status'" :key="key" label="Availability" width="180">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Availability
                      <i class="el-icon-edit" @click="skuSetDiglog('Availability')" data-key="Availability"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <!-- 上架或下架状态 -->
                    <div class="table-cell-input" v-if="scope['row']['showStatusSelect']">
                      <el-select placeholder="Please Select" :disabled="goodsStatusDb == '0' ||scope['row']['isDeleted']"
                                 v-model="scope['row'][item]" @change="e=>changeSkuStatus(e,scope['row'],scope.$index)">
                        <el-option
                          v-for="item in skuStatusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>

                    </div>

                    <!-- 已经设置过补货时间 -->
                    <div class="table-cell-input" v-else>
                      <div style="font-size: 12px;color: #FB541C;">Restock by {{ scope['row']['restockDate'] }}</div>
                      <div class="cust-sku-btn" style="text-align: left;" v-if="!scope['row']['isDeleted']">
                        <span @click="resetRestock(scope['row'],scope.$index)">Restock</span>
                        <span @click="e=>changeSkuRestockDate(e,scope['row']) ">Change Date</span>
                      </div>
                      <div class="cust-sku-btn" style="text-align: left;" v-else>
                        <span style="text-decoration: unset; ">Restock</span>
                        <span style="text-decoration: unset; ">Change Date</span>
                      </div>
                    </div>

                    <!-- 库存补货时间 -->
                    <div class="set-restock-date" v-show="scope['row']['tmpStatus']=='99' && !skuIsDiglog">
                      <p>Set restock date</p>
                      <el-date-picker
                        v-model="restockDateArr[scope.$index]"
                        style="margin-top: 10px;"
                        type="date"
                        :disabled="goodsStatusDb == '0'"
                        value-format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy"
                      >
                      </el-date-picker>
                      <div class="required-error" v-show="!restockDateArr[scope.$index]">Please set restock date</div>
                      <div class="cust-sku-btn">
                        <span @click="submitRestockDate(scope['row'],scope.$index,false)">Cancel</span>
                        <span @click="submitRestockDate(scope['row'],scope.$index,true)">Save</span>
                      </div>
                    </div>

                    <!-- 下架的SPU,SKU操作上架，需要提示“请先将SPU设置成上架 -->
                    <template v-if="!scope['row']['isDeleted']">
                      <div class="required-error" v-show="goodsStatusDb == '0'">Please set SPU Active first</div>
                    </template>
                    <sku-bluk-set field="Availability" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Availability'"></sku-bluk-set>

                  </template>

                </el-table-column>
                <el-table-column v-else-if=" item=='Dimensions - L/W/H(cm)'" :key="key" :label="item" width="220">
                  <template slot="header" slot-scope="scope">
                    <div class="cust-title">
                      Dimensions - L/W/H(cm)
                      <i class="el-icon-edit" @click="skuSetDiglog('Dimensions')" data-key="Dimensions"></i>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-cell-input">
                      <el-input style="width: 50px;"
                                :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value>1000){value=1000}"
                                placeholder="Length" v-model="scope['row']['length']"></el-input>
                      <el-input style="width: 50px;"
                                :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                                placeholder="Width" v-model="scope['row']['width']"></el-input>
                      <el-input style="width: 50px;"
                                :disabled="scope['row']['isDeleted']"
                                oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                                placeholder="High" v-model="scope['row']['height']"></el-input>
                    </div>
                    <template v-if="!scope['row']['isDeleted']">
                      <div class="required-error"
                           v-show="!scope['row']['length'] || !scope['row']['width'] || !scope['row']['height']">L/W/H
                        (cm) can't be blank
                      </div>
                    </template>
                    <sku-bluk-set field="Dimensions" v-if="scope.$index==0 && skuIsDiglog && curSkuBlukField == 'Dimensions'"></sku-bluk-set>

                  </template>
                </el-table-column>

                <el-table-column v-else-if="item==='Vd_SKU ID'" :key="key" :label="item"  :width="calcWidth(item)" fixed>
                  <template slot-scope="scope">
                    <div>{{ scope['row'][item] || '-' }}</div>
                  </template>
                </el-table-column>

                <el-table-column v-else-if="item!=='length' && item!=='width' && item!=='height' && item!=='countryCode'
                              && item!=='serviceFee' && item!=='isDirectlyModifyNetPrice' && item!=='orlNetPrice'
                             && item!=='restockDate' && item!=='skuCharacterList' && item!=='restockDateMmddyyyy'
                            && item!=='Procurement Price($)' "
                                 :key="key" :label="item" :width="calcWidth(item)">
                  <template slot-scope="scope">
                    <div>{{ scope['row'][item] }}</div>
                  </template>
                </el-table-column>

              </template>

              <el-table-column label="Action" width="120" >
                <template slot-scope="scope">
                  <i class="el-icon-delete" style="cursor: pointer;" v-if="!scope['row']['isDeleted']" @click="deleteSku(scope['row'],true)"></i>
                  <i class="el-icon-refresh-right" style="cursor: pointer;"  v-if="scope['row']['isDeleted']" @click="deleteSku(scope['row'],false)"></i>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="all-delete-variant-msg" v-if="showAllDeleteVariantMsg">
            <span @click="showVariant">Please add product Variant first</span>
          </div>
          <div class="required-error" v-if="skuRepeatFlag">
           {{skuRepeat}}
          </div>
        </div>

        <div class="content" style="padding-bottom: 10px;">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Commodity attributes</p>
          <div>
            <el-radio-group @change="changeCommodityAttributes" name="changeCommodityAttributes" v-model="form.commodityAttributes">
              <el-radio :label="4">Ordinary</el-radio>
              <el-radio :label="1">Sensitive</el-radio>
              <el-radio :label="2">Cosmetic</el-radio>
              <el-radio :label="3">Apparel</el-radio>
              <el-radio :label="5">Synthetic Wig</el-radio>
            </el-radio-group>
            <el-checkbox @change="changeIsSpecial" v-show="isAdmin" style="margin-left: 20px" label="Special"
                         name="type" v-model="form.isSpecial"></el-checkbox>
          </div>
          <div class="required-error" v-show="!form.commodityAttributes && (!form['reviewContentList'] || (form['reviewContentList'] && form['reviewContentList'].filter(f=>f['reviewContent']=='commodity_attributes').length==0))">
            Please select Commodity attributes
          </div>
          <div class="required-error" style="margin-top: 2px;"
               v-if="form['reviewContentList'] && form['reviewContentList'].filter(f=>f['reviewContent']=='commodity_attributes').length>0">
            modify is {{form['reviewContentList'].filter(f=>f['reviewContent']=='commodity_attributes') | disUpdateAfterValueCommodityAttributes}}, under review
          </div>
        </div>

        <div class="content">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Customs Name</p>
          <div class="flex">
            <div style="margin-right: 20px;">
              <span class="cust-name">SPU Customs Name_cn</span>
              <el-input class="cust-name-input" @input="inputCnChange" maxlength="50" show-word-limit
                        v-model="form.cnProductName"></el-input>
              <div v-show="form.shippingCountryCode==1 && !form.cnProductName" class="required-form-error">
                Please fill in SPU Customs Name_cn
              </div>
            </div>
            <div>
              <span class="cust-name">SPU Customs Name_en</span>
              <el-input class="cust-name-input" maxlength="50" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"
                        show-word-limit v-model="form.enProductName"></el-input>
              <div v-show="form.shippingCountryCode==1 && !form.enProductName" class="required-form-error">
                Please fill in SPU Customs Name_en
              </div>
            </div>
          </div>
        </div>

        <div class="content">
          <p><span style="color: #F56C6C;">*</span>&nbsp;Status</p>
          <el-select placeholder="Please Select" v-model="form.goodsStatus">
            <el-option
              v-for="item in goodsStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="required-form-error" style="margin-top: 13px;" v-if="form['reviewContentList'] && form['reviewContentList'].filter(f=>f['reviewContent']=='goods_status').length>0">
            modify is {{ form['reviewContentList'].filter(f=>f['reviewContent']=='goods_status') | disUpdateAfterValueStatus }}, under review
          </div>
        </div>

      </div>

    </div>
    <div class="button-list" style="margin-top:20px">
      <el-button @click="save" type="primary" class="save-button">
        Publish
      </el-button>
      <el-button @click="cancel" plain>
        cancel
      </el-button>
      <div class="required-error" v-show="!checkResult">
        Please check all fields
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <sku-variant ref="skuVariant" ></sku-variant>

  </div>
</template>

<script>

import SkuBlukSet from './sku-bluk-set'

import E from 'wangeditor'
import Sortable from 'sortablejs'
import {getAction, putAction, deleteAction, postAction, postActionFile} from '@/api/manage.js'
import i18next from 'i18next'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import {skuStatusArr} from '../../utils/status'
import SkuVariant from './sku-variant'
import QuillEditor from '../components/quillEditor.vue'
let commodityAttributesOptionArrMap = new Map([ ['1', 'Sensitive'], ['2', 'Cosmetic'], ['3', 'Apparel'], ['4', 'Ordinary'], ['5', 'Synthetic Wig'] ])

// import Vue from 'vue'
export default {
  components: {
    SkuVariant,
    SkuBlukSet,
    CustomBreadcrumb,
    QuillEditor
  },
  data() {
    return {
      form: {
        productId: '',
        title: '',
        shippingCountryCode: null,
        goodsStatus: ''
      },
      goodsStatusOptions: [{
        value: '1',
        label: 'Active'
      }, {
        value: '0',
        label: 'Inactive'
      }],
      /**
       *     缺货(0,"Out of stock"),
       *     有货(1,"Active"),
       *     下架(2,"Inactive"),
       */
      skuStatusOptions: skuStatusArr,
      table: [],
      tableKey: Math.random(),
      tableColumn: null,
      editor: null,
      descInfo: null,
      uploadApi: '',
      spuId: '',
      supplierManagementModel: JSON.parse(localStorage.getItem('pro__userInfo')).value.supplierManagementModel, // 供应商经营模式1入驻 2自营
      dialogImageUrl: '',
      dialogVisible: false,
      isAdmin: false,
      checkResult: true, // 校验结果，true通过 false有错
      skuIsDiglog: false, // sku表格，是否存在弹框
      curSkuBlukField: '', // 当前批量编辑字段
      restockDate: '',
      goodsStatusDb: '',
      spuFilelist: [],
      skuFileList: [],
      categoryList: [],
      brandOptions: [],
      brandIdWithShippingMap: new Map(),
      brandIdWithNameMap: new Map(),
      brandIdWithShippingCodeMap: new Map(),
      brandIdWithCommissionRateMap: new Map(),
      brandIdWithShippingModelMap:new Map(),
      restockDateArr: [],
      variantWithValuesListMap: new Map(),
      showAllDeleteVariantMsg: false,
      totalSkuCount: 0,
      productIdRepeat: false,
      skuRepeatFlag: false,
      skuRepeat: '',
      loading: false,
      variantArr: []
    }
  },
  created() {
    this.uploadApi = process.env.API_URL + 'common/image'
    this.getCategoryList()
    this.loadBrands()
  },
  watch: {
    table: {
      handler(n, o) {
        this.showAllDeleteVariantMsg = !n.some(f => !f.isDeleted)
        this.totalSkuCount = n.length
      },
      deep: true
    },
    tableColumn: {
      handler(n, o) {
      },
      deep: true
    }

  },

  filters: {
    disUpdateAfterValue(arr, type) {
      return arr ? arr.filter(f => f['reviewContent'] == type)[0]['reviewValueAfter'] : ''
    },
    disUpdateAfterValueObj(arr, type) {
      return arr ? arr.filter(f => f['reviewContent'] == 'weight')[0] : {}
    },
    disUpdateAfterValueWeight(obj) {
      return obj ? obj['reviewValueAfter'] : ''
    },
    disUpdateAfterValueStatus(obj) {
      let statusCode = obj ? obj[0]['reviewValueAfter'] : ''
      return statusCode == '1' ? 'Active' : 'Inactive'
    },
    disUpdateAfterValueCommodityAttributes(obj) {
      let statusCode = obj ? obj[0]['reviewValueAfter'] : ''
      return commodityAttributesOptionArrMap.get(statusCode)
    },
    disUpdateAfterValueShippingcode(obj) {
      let statusCode = obj ? obj[0]['reviewValueAfter'] : ''
      return statusCode == 1 ? 'China' : 'USA'
    }

  },
  async mounted() {
    const {query} = this.$route
    // let data = await getAction(`/v0.2/brand/products/goods/${query.goodsId}`)
    this.createEditor([])

    let roleData = await getAction(`/sp/suppliers/own-brand`)
    this.isAdmin = roleData['result']['model'] === '4'

    // spu图片
    let imgsData = await getAction(`/sp/suppliers/products/goods/${query.goodsId}/images`)
    this.spuFilelist = imgsData['result'].map((itm, i) => {
      const url = itm['img']
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      return {url: url, name: fileName}
    })

    // 初始化列
    let {result} = await getAction(`/v0.2/brand/products/goods/sku/character`)
    this.tableColumn = result

    this.table = []

    // 初始化特征
    // this.variantWithValuesListMap.set('Color',[])
    this.$refs.skuVariant.initSkuVariant([])

    this.initDragSort()

    document.addEventListener('click', (e) => {
      if (e.target.className != 'sku-bluk' && e.target.className != 'el-icon-edit') {
        this.skuIsDiglog = false
      }
      if (e.target.className == 'el-icon-edit') {
        this.skuIsDiglog = true
      }
    })
  },
  methods: {
    resultDesciption(descInfo) {
      this.descInfo = descInfo
    },
    showVariant() {
      this.$refs.skuVariant.initSkuVariant(this.variantWithValuesListMap)
      this.$refs.skuVariant.visible = true
    },
    deleteSku(row, isDeleted) {
      if (isDeleted) {
        this.$confirm('Make sure you delete this SKU, you can still restore a deleted SKU before submitting the product.', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning'
        }).then(() => {
          this.$set(row, 'isDeleted', true)
          row['isRepeatBrandSku'] = false

          this.refreshVariant(row)
        }).catch(() => {
          console.log('取消删除')
        })
      } else {
        this.$set(row, 'isDeleted', false)
        // sku是否重复
        this.changeBrandSkuCode(row['Brand SKU ID'], row)

        // 刷新编辑
        this.refreshVariant(row)
      }
    },
    refreshVariant(row) {
      this.tableKey = Math.random()

      // 全部删除完毕
      if (!this.table.some(f => !f['isDeleted'])) {
        this.$refs.skuVariant.initSkuVariant([])
        return
      }

      // 刷新编辑规格，只能还原规格值，不能还原规格名，因只记录了上一次操作的值
      this.variantWithValuesListMap.forEach((list, name) => {
        let value = row[name]
        let isExists = this.table.some(f => f[name] == value && !f['isDeleted'])
        if (isExists && !list.includes(value)) {
          list.push(value)
        } else if (!isExists && list.includes(value)) {
          const index = list.indexOf(value)
          list.splice(index, 1)
        }
      })
      console.log(this.variantWithValuesListMap, '刷新规格')
      this.$refs.skuVariant.initSkuVariant(this.variantWithValuesListMap)
    },
    clickBrandSkuCode(e) {
      e.focus()
      console.log(e)
    },
    changeBrandSkuCode(e, row) {
      let newSkuArr = this.table.filter(f => f['Brand SKU ID'] == e && !f['isDeleted'])
      row['isRepeatBrandSku'] = false
      if (newSkuArr.length > 1) {
        row['isRepeatBrandSku'] = true
      } else {
        row['brandSkuIdHistory'] = e
      }
    },
    changeSkuRestockDate(e, row) {
      // scope['row']['tmpStatus']='99';
      this.$set(row, 'tmpStatus', '99')
      this.skuIsDiglog = false
    },
    async getCategoryList() {
      let response = await getAction('/tsCategory/tsCateInfo/all-list')
      let tempCategoryList = []
      if (response.success) {
        let categoryList = response.result
        if (categoryList) {
          categoryList.forEach((category, index) => {
            let secondCategoryList = category.childrenList
            secondCategoryList.forEach((secondCategory, secondIndex) => {
              let thirdCategoryList = secondCategory.childrenList
              thirdCategoryList.forEach((thirdCategory, thirdIndex) => {
                const categoryObject = {}
                categoryObject.value = thirdCategory.id
                categoryObject.label = category.cateName + ' / ' + secondCategory.cateName + ' / ' + thirdCategory.cateName
                tempCategoryList.push(categoryObject)
              })
            })
          })
        }
        this.categoryList = tempCategoryList
      } else {
        this.$message.warning(response.message)
      }
    },
    changeCate(e) {
      this.form['categoryIsOutOfStock'] = false
      if (this.form['cateIdDb'] == e && this.form['categoryIsOutOfStockDb']) {
        this.form['categoryIsOutOfStock'] = true
      }
    },
    // 获取品牌
    loadBrands(name) {
      const userInfo = this.$ls.get('userInfo')
      const supplierId = userInfo.id
      const brandName = name || ''
      getAction(`/v0.2/brands/suppliers/${supplierId}/brands?brandName=${brandName}`).then(res => {
        if (res.success) {
          this.brandOptions = res.result.map(e => {
            const status = e['isDeleted'] === 0 ? 'Active' : 'Inactive'
            // shippingFree 送货状态1免费 2收费
            this.brandIdWithShippingMap.set(e.id, e['shippingFree'] == 1)
            this.brandIdWithNameMap.set(e.id, e['brandName'])
            this.brandIdWithShippingCodeMap.set(e.id, e['shippingCountryCode'])
            this.brandIdWithCommissionRateMap.set(e.id, e['commissionRate'])
            this.brandIdWithShippingModelMap.set(e.id, e['brandShippingModel'])
            return {
              label: e.brandName + '-' + status,
              value: e.id
            }
          })
        }
      }).catch(() => {
      })
    },
    changBrand(e) {
      this.form.isFreeShipping = this.brandIdWithShippingMap.get(e)
      this.form['commissionRate'] = this.brandIdWithCommissionRateMap.get(e)
      this.form.shippingCountryCode = this.brandIdWithShippingCodeMap.get(e) === 'China' ? 1 : 2
      // 2.2.14 增加传递 品牌发货模式
      this.form.brandShippingModel = this.brandIdWithShippingModelMap.get(e)
      // 如果有SKU，则更新
      if (this.table && this.table.length > 0) {
        this.handlePrice('', '')
      }
    },
    changeShippingCountry(e) {
      // 如果有SKU，则更新
      if (this.table && this.table.length > 0) {
        this.handlePrice('', '')
      }
    },

    createEditor(data) {
      // let descInfo = ''
      /* let descInfo = data['descInfo']
       this.descInfo = descInfo
       this.form = data
       this.form['cateIdDb'] = data['cateId']
       this.form['categoryIsOutOfStockDb'] = data['categoryIsOutOfStock']
       this.goodsStatusDb = data['goodsStatus'] */
      this.form['goodsStatus'] = '1'

      // this.editor = new E('#editor')
      // this.editor.config.height = 300
      // this.editor.config.lang = 'en'
      // // this.editor.i18next = i18next
      // this.editor.i18next = i18next

      // add by cpgu 2023/05/17 begin
      // this.custConfigEditor()
      // end by cpgu

      // this.editor.create()
      // this.editor.txt.html(descInfo)
      this.$nextTick(() => {
        let menuList = document.querySelectorAll('.w-e-menu')
        menuList.forEach((e, i) => {
          e.setAttribute('data-title', '')
        })
      })
    },
    custConfigEditor() {
      // add by cpgu 2023/05/17 begin

      // https://www.shuzhiduo.com/A/amd0g2Vq5g/

      // 开启本地上传图片(这是后端上传链接)
      this.editor.config.uploadImgServer = this.uploadApi
      // 隐藏“网络图片”tab
      this.editor.config.showLinkImg = false
      // 设置上传图片http请求参数名，
      this.editor.config.uploadFileName = 'file'
      // 设置请求头  解决跨域问题
      this.editor.config.uploadImgHeaders = {'Access-Control-Allow-Origin': 'origin'}
      // 将图片大小限制为5M
      // this.editor.config.uploadImgMaxSize=5*1024*1024;
      // 一次最多上传图片的数量
      // this.editor.config.uploadImgMaxLength = 1;
      // 限制上传图片格式
      this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      this.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'image', // 插入图片
        'table', // 表格
        'undo', // 撤销
        'redo' // 重复
      ]

      let that = this
      this.editor.config.uploadImgHooks = {
        customInsert: function (insertImg, result, editor) {
          if (result.success) {
            // 插入图片到编辑器中
            insertImg(result.result)
          } else {
            that.$message.error('Failed to upload image')
          }
        }
      }
      this.editor.config.onchange = newHtml => {
        // console.log('change 之后最新的 html', newHtml)
        this.form.descInfo = newHtml
        this.descInfo = newHtml
      }
      // end by cpgu
    },
    cancel() {
      this.$router.push({
        path: 'Products'
      })
    },
    changeIsSpecial(event) {
      this.handlePrice(event, 'isSpecial')
    },
    changeCommodityAttributes(event) {
      let value = Number(event)
      if (value) {
        this.handlePrice(value, 'commodityAttributes')
      }
    },
    handlePrice(value, type) {
      if (!this.form['collectionBrandId'] || !this.form['shippingCountryCode']) {
        return
      }
      for (let index = 0; index < this.table.length; index++) {
        const row = this.table[index]

        let param = {}
        // notes 初始化
        param.commodityAttributes = this.form['commodityAttributes']
        param.isFreeShipping = this.form['isFreeShipping']
        param.commissionRate = this.form['commissionRate']
        param.isSpecial = this.form['isSpecial']
        param.weight = row['Weight(g)']
        param.skuId = row['id']
        param.shippingCountryCode = row['countryCode']
        if (param.weight) {
          // 判断当前人物的角色来传什么
          if (this.supplierManagementModel === 2) {
            param.costPrice = row['Cost Price($)']
          } else {
            param.fobPrice = row['FOB Price($)']
          }
        }
        if (type) {
          param[type] = value
        }
        getAction(`/v0.2/brand/skus/brand/${this.form['collectionBrandId']}/price?shippingCountry=${this.form['shippingCountryCode']}&brandId=${this.form['collectionBrandId']}`, param).then(response => {
          if (response.success) {
            const result = response.result
            if (result) {
              // 2.2.14 增加逻辑 只有第一次建议零售价自动关联，后续的不做更新
              if(!this.table[index].isAutoUpdateRetailPriceFlag && !this.table[index].isDirectlyModifyNetPrice){
                this.$set(this.table[index], 'isAutoUpdateRetailPriceFlag', true)
                this.$set(this.table[index], 'isDirectlyModifyNetPrice', true)
                this.$set(this.table[index], 'Retail Price($)', result.suggestedRetailPrice)
              }
              if (result.fobPrice) {
                this.$set(this.table[index], 'FOB Price($)', result.fobPrice)
              }
              if (result.costPrice) {
                this.$set(this.table[index], 'Cost Price($)', result.costPrice)
              }
              this.$set(this.table[index], 'Wholesale Price($)', result.cifPrice)

            }
          } else {
            this.$message.warning(response.message)
          }
        }).catch(err => {
          this.$message.warning(err)
        })
      }

      /* postAction('/v0.2/brand/skus/price?commissionRate=' + this.form['commissionRate'], params).then(response => {
        if (response.success) {
          const resultList = response.result
          if (resultList) {
            // notes 根据对应的SKUID 把新返回的cif 和 suggest price 进行重新赋值
            const mapWithSkuId = new Map()
            for (var resultIndex = 0; resultIndex < resultList.length; resultIndex++) {
              const resultObject = resultList[resultIndex]
              mapWithSkuId[resultObject['skuId']] = resultObject
            }
            // 将返回组按skuId分组后进行查询
            let tempTable = this.table
            for (var tableIndex = 0; tableIndex < tempTable.length; tableIndex++) {
              const tableObject = tempTable[tableIndex]
              const skuObject = mapWithSkuId[tableObject['id']]
              tableObject['Wholesale Price($)'] = skuObject.cifPrice
              tableObject['Retail Price($)'] = skuObject.suggestedRetailPrice
            }
            this.table = tempTable
          }
        } else {
          this.$message.warning = response.message
        }
      }).catch(err => {
        this.$message.warning = err
      })
      */
    },
    blurWeight(event, index, row) {
      let value = Number(event)
      if (value) {
        this.handleRowPrice(false, row, index, false, value)
      }
    },
    blurCif(event, index, row) {
      this.loading = true
      if (!event && !row['oldCifPrice']) {
        this.$set(this.table[index], 'Wholesale Price($)', 0)
        this.loading = false
        return
      }

      let value = Number(event.target.value)
      // let value = Number(event)
      if (!value) {
        value = Number(row['oldCifPrice'])
        this.$set(this.table[index], 'Wholesale Price($)', value.toFixed(1))
      }

      if (value) {
        this.handleRowPrice(value.toFixed(1), row, index, 'cifPrice', false)
        /**
         * 履约服务费=商品重量*0.009 (v1 版本)
         * CIF=FOB+履约服务费
         * Suggested retail price=(CIF*2)+履约服务费
         * 美国发货的商品没有履约服务费，中国发货的商品有履约服务费，且不是免邮
         *
         */
        // let servicePrice = 0
        // if (!this.form['isFreeShipping'] && row['countryCode'] !== 'US') {
        //   servicePrice = row['serviceFee'] * row['Weight(g)']
        // }
        // this.$set(this.table[index], 'Wholesale Price($)', (value + servicePrice).toFixed(2))
        // this.$set(this.table[index], 'Retail Price($)', (value * 2 + servicePrice).toFixed(2))
        // // 品牌入驻模式成本价=FOB*（1-品牌佣金率）
        // let costPrice = value - (this.form['commissionRate'] ? this.form['commissionRate'] : 0) * value
        // this.$set(this.table[index], 'Cost Price($)', (costPrice).toFixed(2))
      }
    },
    blurFob(event, index, row) {
      if (!event && !row['oldFobPrice']) {
        this.$set(this.table[index], 'FOB Price($)', 0)
        return
      }

      // let value = event.target.value
      let value = Number(event)
      if (!value) {
        value = Number(row['oldFobPrice'])
        this.$set(this.table[index], 'FOB Price($)', value)
      }

      if (value) {
        this.handleRowPrice(value, row, index, 'fobPrice', false)
        /**
         * 履约服务费=商品重量*0.009 (v1 版本)
         * CIF=FOB+履约服务费
         * Suggested retail price=(CIF*2)+履约服务费
         * 美国发货的商品没有履约服务费，中国发货的商品有履约服务费，且不是免邮
         *
         */
        // let servicePrice = 0
        // if (!this.form['isFreeShipping'] && row['countryCode'] !== 'US') {
        //   servicePrice = row['serviceFee'] * row['Weight(g)']
        // }
        // this.$set(this.table[index], 'Wholesale Price($)', (value + servicePrice).toFixed(2))
        // this.$set(this.table[index], 'Retail Price($)', (value * 2 + servicePrice).toFixed(2))
        // // 品牌入驻模式成本价=FOB*（1-品牌佣金率）
        // let costPrice = value - (this.form['commissionRate'] ? this.form['commissionRate'] : 0) * value
        // this.$set(this.table[index], 'Cost Price($)', (costPrice).toFixed(2))
      }
    },
    blurRetailPriceFob(event, index, row) {
      if (!event && !row['oldRetailPrice']) {
        this.$set(this.table[index], 'Retail Price($)', 0)
        return
      }

      let value = Number(event)
      if (value) {
        this.$set(this.table[index], 'isDirectlyModifyNetPrice', true)
        // 检查尾数
        if (
          !(Math.abs(value - Math.round(value) * 100) / 100 === 0.99 &&
            Math.abs(value - Math.round(value) * 100) % 100 === 0) &&
          !(Math.abs(value - Math.round(value) * 100) / 100 === 0.49 &&
            Math.abs(value - Math.round(value) * 100) % 100 === 0)
        ) {

          // 如果尾数不是.99或.49，则进行修正或给出提示
          // 这里只是示例，你可能需要根据实际情况进行修正
          // 例如，四舍五入到最近的.99或.49
          // const roundedValue = Math.round(value * 100) / 100;
          if (Math.abs(value - Math.floor(value)) < 0.5) {
            value = Math.floor(value) + '.49';
          } else {
            value = Math.floor(value) + '.99';
          }
        }
        this.$set(this.table[index], 'Retail Price($)', value)
      }
      if (!value) {
        value = Number(row['oldRetailPrice'])
        this.$set(this.table[index], 'Retail Price($)', value)
      }
    },

    blurCostPriceFob(event, index, row) {
      let value = Number(event.target.value)
      if (value) {
        this.handleRowPrice(value, row, index, 'costPrice', false)

        // 服务费
        // let servicePrice = 0
        // if (!this.form['isFreeShipping'] && row['countryCode'] !== 'US') {
        //   servicePrice = row['serviceFee'] * row['Weight(g)']
        // }
        // // 品牌佣金率
        // let commissionRate = (this.form['commissionRate'] ? this.form['commissionRate'] : 1)
        // // FOB Price=成本价/(1-佣金率)
        // let fobPrice = (value / (1 - commissionRate))

        // // SKU建议零售价=FOB Price * 2 + Cross-Boarder Freight （Cross-Boarder Freight为履约服务费）
        // this.$set(this.table[index], 'FOB Price($)', fobPrice.toFixed(2))
        // this.$set(this.table[index], 'Wholesale Price($)', (fobPrice + servicePrice).toFixed(2))
        // this.$set(this.table[index], 'Retail Price($)', (fobPrice * 2 + servicePrice).toFixed(2))
      }
    },
    handleRowPrice(value, row, index, price, weight) {
      if (!this.form['collectionBrandId'] || !this.form['shippingCountryCode']) {
        this.loading = false
        return
      }
      const param = {}
      // notes 初始化
      param.commodityAttributes = this.form['commodityAttributes']
      param.isFreeShipping = this.form['isFreeShipping']
      param.commissionRate = this.form['commissionRate']
      param.isSpecial = this.form['isSpecial']
      param.weight = row['Weight(g)']
      param.skuId = row['id']
      param.shippingCountryCode = row['countryCode']
      if (weight) {
        param.weight = weight
        // 判断当前人物的角色来传什么
        if (this.supplierManagementModel === 2) {
          param.costPrice = row['Cost Price($)']
        } else {
          // param.fobPrice = row['FOB Price($)']
          param.cifPrice = row['Wholesale Price($)']
        }
      }
      if (price) {
        param[price] = value
      }
      let reqUrl = row['id'] ? `/v0.2/brand/skus/${row['id']}/price?brandShippingModel=${this.form['brandShippingModel']}` : `/v0.2/brand/skus/brand/${this.form['collectionBrandId']}/price?shippingCountry=${this.form['shippingCountryCode']}&brandShippingModel=${this.form['brandShippingModel']}`
      getAction(reqUrl, param).then(response => {
        if (response.success) {
          this.loading = false
          const result = response.result
          if (result) {
            // 2.2.14 增加逻辑 只有第一次建议零售价自动关联，后续的不做更新
            if(!this.table[index].isAutoUpdateRetailPriceFlag && !this.table[index].isDirectlyModifyNetPrice){
              // this.$set(this.table[index], 'isAutoUpdateRetailPriceFlag', true)
              // this.$set(this.table[index], 'isDirectlyModifyNetPrice', true)
              this.$set(this.table[index], 'Retail Price($)', result.suggestedRetailPrice)
            }
            if (price === 'costPrice') {
              this.$set(this.table[index], 'FOB Price($)', result.fobPrice)
            } else if (price === 'fobPrice') {
              this.$set(this.table[index], 'Cost Price($)', result.costPrice)
            } else {
              // this.$set(this.table[index], 'FOB Price($)', result.fobPrice)
              // this.$set(this.table[index], 'Cost Price($)', result.costPrice)
              if (result.fobPrice) {
                this.$set(this.table[index], 'FOB Price($)', result.fobPrice)
              }
              if (result.costPrice) {
                this.$set(this.table[index], 'Cost Price($)', result.costPrice)
              }
            }
            this.$set(this.table[index], 'Wholesale Price($)', result.cifPrice)

          }
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.loading = false
        this.$message.warning(err)
      })
    },
    async save() {
      this.loading = true
      if (!this.checkForm()) {
        this.loading = false
        this.checkResult = false
        return
      }

      const {query} = this.$route
      let newSkuList = []
      if (this.supplierManagementModel == '2') {
        /**
         * 注意：
         * 1、自营模式删除oldCifPrice、cifPrice、oldRetailPrice、retailPrice注释（自营模式修改重量，运营账号需要看见CIF审核信息）。
         * 2、暂不知道影响范围，也暂不清楚之前是何种原因注释。
         * Author : modify by cpgu 2023/04/13
         */
        newSkuList = this.table.filter(f => f['Brand SKU ID']).map((e, i) => {
          let characterItems = []
          this.variantWithValuesListMap.forEach((list, name) => {
            let obj = {
              optionName: name,
              optionValue: e[name]
            }
            characterItems.push(obj)
          })
          return {
            skuId: e['id'],
            skuImg: e['Image'],
            brandSkuId: e['Brand SKU ID'],
            step: Number(e['Case']),
            fobPrice: e['FOB Price($)'],
            oldCifPrice: e['oldCifPrice'],
            cifPrice: e['Wholesale Price($)'],
            oldRetailPrice: e['oldRetailPrice'],
            retailPrice: e['Retail Price($)'],
            sourcePrice: e['Cost Price($)'],
            length: Number(e['length']),
            width: Number(e['width']),
            height: Number(e['height']),
            weight: Number(e['Weight(g)']),
            inventory: Number(e['Inventory']),
            netPrice: e['Retail Price($)'],
            isDirectlyModifyNetPrice: e['isDirectlyModifyNetPrice'],
            procurementPrice: e['Procurement Price($)'],
            kaSettlementPrice: e['Wholesale Settlement Price($)'],
            status: e['status'],
            restockDate: e['restockDate'],
            isDeleted: e['isDeleted'],
            characterItems: characterItems
          }
        })
      } else {
        newSkuList = this.table.filter(f => f['Brand SKU ID']).map((e, i) => {
          let characterItems = []
          this.variantWithValuesListMap.forEach((list, name) => {
            let obj = {
              optionName: name,
              optionValue: e[name]
            }
            characterItems.push(obj)
          })
          return {
            skuId: e['id'],
            skuImg: e['Image'],
            brandSkuId: e['Brand SKU ID'],
            step: Number(e['Case']),
            fobPrice: e['FOB Price($)'],
            oldCifPrice: e['oldCifPrice'],
            cifPrice: e['Wholesale Price($)'],
            oldRetailPrice: e['oldRetailPrice'],
            retailPrice: e['Retail Price($)'],
            sourcePrice: e['Cost Price($)'],
            length: Number(e['length']),
            width: Number(e['width']),
            height: Number(e['height']),
            weight: Number(e['Weight(g)']),
            inventory: Number(e['Inventory']),
            netPrice: e['Retail Price($)'],
            isDirectlyModifyNetPrice: e['isDirectlyModifyNetPrice'],
            procurementPrice: e['Procurement Price($)'],
            kaSettlementPrice: e['Wholesale Settlement Price($)'],
            status: e['status'],
            restockDate: e['restockDate'],
            isDeleted: e['isDeleted'],
            characterItems: characterItems
          }
        })
      }

      let spuImgArr = this.spuFilelist.map((e, i) => {
        return {
          img: e.url,
          seq: (i + 1)
        }
      })
      this.form.descInfo = this.descInfo
      let saveData = {
        tsGoodsInfo: {
          ...this.form
        },
        skuInfoList: newSkuList,
        tsGoodsImgList: spuImgArr
      }
      // TODO 需要加上规格的顺序
      let characterSort = []
      this.variantArr.forEach((item) => {
        const characterObject = {}
        characterObject.optionName = item.variantName
        characterObject.optionValueList = item.tagArr
        characterSort.push(characterObject)
      })
      saveData.characterSort = characterSort
      console.log(saveData)
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      let changeData = await postAction(`/product/api/v0.2/suppliers/${userInfo.id}/product/add`, saveData)
      this.productIdRepeat = false
      this.skuRepeatFlag = false
      if (!changeData.success) {
        this.$message.warning(changeData.message)
        this.productIdRepeat = changeData.message == 'Duplicate SPU ID, please modify'
        if (changeData.message && changeData.message.indexOf('Duplicate SKU ID,please modify') > 0) {
          this.skuRepeatFlag = true
          this.skuRepeat = changeData.message
        }
        this.loading = false
      } else {
        this.loading = false
        this.$message.success(changeData.message)
        this.$router.push({
          path: 'Products'
        })
      }
    },
    checkForm() {
      this.checkResult = true

      // this.descInfo = this.editor.txt.html()
      if (!this.form.productId || !this.form.title || !this.form['cateId'] || !this.form['shippingCountryCode'] || !this.form.collectionBrandId || this.form['categoryIsOutOfStock'] ||
        !this.descInfo ||
        (!this.form.commodityAttributes && (!this.form['reviewContentList'] || (this.form['reviewContentList'] && this.form['reviewContentList'].filter(f => f['reviewContent'] == 'commodity_attributes').length == 0))) ||
        this.spuFilelist.length < 1 || this.showAllDeleteVariantMsg) {
        return false
      }
      //   shippingCountryCode:  1 China 2 USA   1. 如果“品牌上发货地”是美国，不需要填写中英文报关名称；只有中国发货必段需要填写中英文报关名称
      if (this.form.shippingCountryCode == 1 && (!this.form.cnProductName || !this.form.enProductName)) {
        return false
      }

      // scope['row']['Retail Price($)']<scope['row']['Wholesale Price($)']
      let tabArr2 = this.table.filter(f => !f['isDeleted']).filter(f => {
        return Number(f['Wholesale Price($)'])>0 && ( (Number(f['Retail Price($)'])-Number(f['Wholesale Price($)']))/Number(f['Retail Price($)']) ) <=0.3
      })
      if (tabArr2.length > 0) {
        return false
      }

      // 入驻
      if (this.supplierManagementModel == 1) {
        let tabArr = this.table.filter(f => !f['isDeleted']).filter(f => f['Brand SKU ID']).filter(f => {
          let brandId = f['Brand SKU ID'],
            fobFirce = f['FOB Price($)'],
            weight = f['Weight(g)'],
            inventory = f['Inventory'],
            length = f['length'],
            width = f['width'],
            height = f['height']
          return !brandId || !fobFirce || !weight || !inventory || !length || !width || !height
        })
        return !(tabArr.length > 0)
      } else {
        let tabArr = this.table.filter(f => !f['isDeleted']).filter(f => f['Brand SKU ID']).filter(f => {
          let brandId = f['Brand SKU ID'],
            costPirce = f['Cost Price($)'],
            weight = f['Weight(g)'],
            inventory = f['Inventory'],
            length = f['length'],
            width = f['width'],
            height = f['height']
          return !brandId || !costPirce || !weight || !inventory || !length || !width || !height
        })
        return !(tabArr.length > 0)
      }
    },
    handleRemove(file, fileList) {
      let newFiles = [...this.spuFilelist]
      this.spuFilelist = newFiles.filter(f => f.uid !== file.uid)
      this.removeImage(file)
    },
    handleSkuRemove(file, fileList, index) {
      let tmpSkuArr = [...this.skuFileList]
      tmpSkuArr[index] = []
      this.skuFileList = tmpSkuArr
      this.$set(this.table[index], 'Image', '')
      this.removeImage(file)
    },
    removeImage(removeUrl) {
      // const url = removeUrl.response ? removeUrl.response.result : removeUrl.url
      // deleteAction('/common/image', { path: url }).then((response) => {
      //   if (response.success) {
      //     this.$message({
      //       message: 'successfully deleted!',
      //       type: 'success'
      //     })
      //   }
      // })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSuccess(response, file, fileList) {
      let url = response.result
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      this.spuFilelist.push({url: url, name: fileName})
    },
    uploadRequest(param) {
      let fileObj = param.file
      let form = new FormData()
      form.append('file', fileObj)
      postActionFile(`/common/image`, form, {
        process: function (event) {
          param.file.percent = event.loaded / event.total * 100
          param.onprogress(param.file)
        }
      }).then(res => {
        this.handleSuccess(res)
      }).catch(res => {
        // this.uploadError();
      })
    },
    handleSkuSuccess(response, file, fileList, index) {
      let url = response.result
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      // this.spuFilelist.push({url: url, name: fileName});
      // 设置对应行文件路径
      this.$set(this.table[index], 'Image', url)
    },
    inputCnChange(e) {
      let val = e.replace(/[^\u4E00-\u9FA5]/g, '')
      this.form.cnProductName = val
    },
    async changeSkuStatus(status, row, index) {
      // if (status !== '0') {
      //   let res = await putAction(`/v0.2/brand/sku/${row['id']}/${status}`)
      //   this.$message.info(res.message)
      this.$set(this.table[index], 'status', status)
      // }
      // tmpStatus设置为99，变量为后续判断使用
      this.$set(this.table[index], 'tmpStatus', status == '0' ? '99' : '')
      this.skuIsDiglog = false
    },
    submitRestockDate(row, index, isSave) {
      if (isSave) {
        if (!this.restockDateArr[index]) {
          return
        }
        this.$set(row, 'restockDate', this.restockDateArr[index])
        this.$set(this.table[index], 'status', '0')
        this.$set(this.table[index], 'showStatusSelect', false)

        /* let res = await putAction(`/v0.2/brand/sku/${row['id']}/0?restockDate=${this.restockDate}`)
        if (res['success']) {
          this.$message.info('successful')
          this.$set(this.table[index], 'status', '0')
          this.$set(this.table[index], 'showStatusSelect', false)
          // 这行代码，是对上面哪行代码的加强，因为有时候不生效。
          await this.initSku()
        } else {
          this.$message.error('fail')
        } */
      }

      // 如果点击了取消，并且没有设置补货日期，则还原成数据库值（如果此时数据库的值为缺货，则不允许取消）
      if (!isSave && !this.restockDateArr[index]) {
        this.$set(row, 'status', row['statusDb'])
        if (row['statusDb'] == 0) {
          return
        }
      }

      this.$set(this.table[index], 'tmpStatus', '')
    },
    async resetRestock(row, index) {
      if (this.goodsStatusDb == '0') {
        return
      }
      this.$set(this.table[index], 'status', '1')
      this.$set(row, 'restockDate', '')
      this.restockDateArr[index] = ''

      // 显示下拉框
      this.$set(row, 'showStatusSelect', true)

      /* let res = await putAction(`/v0.2/brand/sku/${row['id']}/1`)
      if (res['success']) {
        this.$message.info('successful')
        this.$set(this.table[index], 'status', '1')
        await this.initSku()
      } else {
        this.$message.error('fail')
      } */
    },
    initDragSort() {
      // 支持拖拽排序
      const el = this.$refs.upload.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({oldIndex, newIndex}) => {
          // 交换位置
          const arr = this.spuFilelist
          const page = arr[oldIndex]
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
        }
      })
    },
    // 跳转库存列表页
    handleInventory(id) {
      this.$router.push({path: `sku-inventory?id=${id}`})
    },

    // 自动计算表头宽度
    calcWidth(label) {
      let flexWidth = 0
      for (const char of label) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
          // 如果是英文字符，为字符分配12个单位宽度
          flexWidth += 12
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20
        } else {
          // 其他种类字符，为字符分配15个单位宽度
          flexWidth += 15
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 100
      }
      return flexWidth + 'px'
    },

    skuSetDiglog(field) {
      if (this.skuIsDiglog) {
        return
      }
      this.curSkuBlukField = field
      this.skuIsDiglog = true
    },

    blukSetSku(type, value, secondValue, thirdValue) {
      switch (type) {
        // 起订量\重量\库存
        case 'num':
          this.buildSkuNum(value)
          break
        // 价格相关
        case 'float':
          this.buildPrice(value, secondValue)
          break
        case 'num-dim':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              x['length'] = value
              x['width'] = secondValue
              x['height'] = thirdValue
            }
          })
          break
        case 'status':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              x['showStatusSelect'] = value !== '0'
              x['status'] = value
              x['restockDate'] = secondValue
              this.restockDateArr[i] = secondValue
            }
          })
          break
      }
      this.skuIsDiglog = false
    },
    buildPrice(modifyValue, operator) {
      debugger
      // FOB Price\Cost Price\Procurement Price\\Wholesale Settlement Price\Retail Price
      switch (this.curSkuBlukField) {
        case 'FOB Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              let newValue = eval(Number(x['FOB Price($)']) + operator + modifyValue)
              x['FOB Price($)'] = newValue.toFixed(2)
              this.blurFob(newValue, i, x)
            }
          })
          break
        case 'Wholesale Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              let newValue = eval(Number(x['Wholesale Price($)']) + operator + modifyValue)
              x['Wholesale Price($)'] = newValue.toFixed(2)
              this.blurCif(newValue, i, x)
            }
          })
          break
        case 'Cost Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              let newValue = eval(Number(x['Cost Price($)']) + operator + modifyValue)
              x['Cost Price($)'] = newValue.toFixed(2)
              this.blurCostPriceFob(newValue, i, x)
            }
          })
          break
        case 'Procurement Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              debugger
              let newValue = eval(Number(x['Procurement Price($)']) + operator + modifyValue)
              x['Procurement Price($)'] = newValue.toFixed(2)
            }
          })
          break
        case 'Wholesale Settlement Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              let newValue = eval(Number(x['Wholesale Settlement Price($)']) + operator + modifyValue)
              x['Wholesale Settlement Price($)'] = newValue.toFixed(2)
            }
          })
          break
        case 'Retail Price':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              let newValue = eval(Number(x['Retail Price($)']) + operator + modifyValue)
              x['Retail Price($)'] = newValue.toFixed(2)
              this.blurRetailPriceFob(newValue, i, x)
            }
          })
          break
      }
    },
    buildSkuNum(newValue) {
      switch (this.curSkuBlukField) {
        case 'Case':
          this.table.map((x, i) => {
            if (!x['isDeleted']) {
              x['Case'] = newValue
            }
          })
          break
        case 'Weight':
          this.table.map((x, i) => {
            if (!x['isDeleted']) { x['Weight(g)'] = newValue }
          })
          break
        case 'Inventory':
          this.table.map((x, i) => {
            if (!x['isDeleted']) { x['Inventory'] = newValue }
          })
          break
      }
    },

    combinationSku(variantArr) {
      this.variantArr = variantArr
      /**
       * 规则如下：
       * 1、添加或删除一组规格（规格名+规格值），清空所有sku信息，然后初始化SKU
       * 2、删除规格值，不操作规格名，则删除相应的sku（界面禁用，置灰）
       */
      // 判断是否发生变化（如果没有变化，则不做任何修改）
      let {
        isChanged,
        isNameChanged,
        addChangeValuesMap,
        deleteNameWithValuesMap,
        existsSkuDelete
      } = this.loadVariantIsChange(variantArr)
      console.log(isChanged, 'isChanged', variantArr, this.variantWithValuesListMap)

      if (isChanged) {
        // 判断是否规格（组）发生了变化
        if (isNameChanged) {
          this.vriantGroupChange(variantArr)
        }
        // 判断是否仅仅是规格值发生了变化
        else if (addChangeValuesMap.size > 0 || deleteNameWithValuesMap.size > 0) {
          this.vriantValueChange(variantArr, addChangeValuesMap, deleteNameWithValuesMap)
        }
        // 列表存在删除的SKU，点击后，需要重新组合出来
        else if (existsSkuDelete) {
          this.skuDeleteChange(variantArr)
        }
        this.tableKey = Math.random()

        let that = this
        // setTimeout(() => {
        //   // 更新当前特征
        //   this.variantWithValuesListMap.clear()
        //   variantArr.forEach(info => {
        //     this.variantWithValuesListMap.set(info['variantName'], [...info['tagArr']])
        //   })
        //   console.log('after:', this.variantWithValuesListMap)
        // }, 800)
      }
      // 只要保存后就更新
      this.variantWithValuesListMap.clear()
      variantArr.forEach(info => {
        this.variantWithValuesListMap.set(info['variantName'], [...info['tagArr']])
      })
      console.log('after:', this.variantWithValuesListMap)
    },
    /**
     * sku有删除变更
     * @param variantArr
     */
    skuDeleteChange(variantArr) {
      // 此处经过确认，不需要过滤逻辑删除的数据
      let curSkuArr = [...this.table]
      switch (variantArr.length) {
        case 1:
          {
            let oneGroupVariant = variantArr[0]
            for (const one of oneGroupVariant['tagArr']) {
              let isExists = curSkuArr.some(sku => sku[oneGroupVariant['variantName']] === one)
              if (!isExists) {
                let obj = {}
                obj[oneGroupVariant['variantName']] = one
                this.otherCommonInitField(obj)
                this.table.push(obj)
              }
            }
          }
          break
        case 2:
          {
            let oneGroupVariant = variantArr[0]
            let twoGroupVariant = variantArr[1]
            for (const one of oneGroupVariant['tagArr']) {
              for (const two of twoGroupVariant['tagArr']) {
                let isExists = curSkuArr.some(sku => sku[oneGroupVariant['variantName']] === one && sku[twoGroupVariant['variantName']] === two)
                if (!isExists) {
                  let obj = {}
                  obj[oneGroupVariant['variantName']] = one
                  obj[twoGroupVariant['variantName']] = two
                  this.otherCommonInitField(obj)
                  this.table.push(obj)
                }
              }
            }
          }
          break
        default: {
          let oneGroupVariant = variantArr[0]
          let twoGroupVariant = variantArr[1]
          let thirdGroupVariant = variantArr[2]
          for (const one of oneGroupVariant['tagArr']) {
            for (const two of twoGroupVariant['tagArr']) {
              for (const third of thirdGroupVariant['tagArr']) {
                let isExists = curSkuArr.some(sku => sku[oneGroupVariant['variantName']] === one && sku[twoGroupVariant['variantName']] === two &&
                  sku[thirdGroupVariant['variantName']] === third)
                if (!isExists) {
                  let obj = {}
                  obj[oneGroupVariant['variantName']] = one
                  obj[twoGroupVariant['variantName']] = two
                  obj[thirdGroupVariant['variantName']] = third
                  this.otherCommonInitField(obj)
                  this.table.push(obj)
                }
              }
            }
          }
        }
      }
    },
    /**
     * 值变更
     * @param variantArr
     */
    vriantValueChange(variantArr, addChangeValuesMap, deleteNameWithValuesMap) {
      if (addChangeValuesMap.size > 0) {
        addChangeValuesMap.forEach((list, name) => {
          let otherGroupArr = variantArr.filter(info => info['variantName'] !== name)
          switch (otherGroupArr.length) {
            case 1:
              let oneGroupVariant = otherGroupArr[0]
              for (const one of oneGroupVariant['tagArr']) {
                for (let value of list) {
                  let exists = this.table.some(f => f[name].toLowerCase() == value.toLowerCase() && f[oneGroupVariant['variantName']].toLowerCase() == one.toLowerCase())
                  if (!exists) {
                    let obj = {}
                    obj[name] = value
                    obj[oneGroupVariant['variantName']] = one
                    this.otherCommonInitField(obj)
                    this.table.push(obj)
                  }
                }
              }

              break
            case 2: {
              let oneGroupVariant = otherGroupArr[0]
              let twoGroupVariant = otherGroupArr[1]
              for (const one of oneGroupVariant['tagArr']) {
                for (const two of twoGroupVariant['tagArr']) {
                  for (let value of list) {
                    let exists = this.table.some(f => f[name].toLowerCase() == value.toLowerCase() && f[oneGroupVariant['variantName']].toLowerCase() == one.toLowerCase() && f[twoGroupVariant['variantName']].toLowerCase() == two.toLowerCase())
                    if (!exists) {
                      let obj = {}
                      obj[name] = value
                      obj[oneGroupVariant['variantName']] = one
                      obj[twoGroupVariant['variantName']] = two
                      this.otherCommonInitField(obj)
                      this.table.push(obj)
                    }
                  }
                }
              }
            }
              break
            default:
              for (let value of list) {
                let exists = this.table.some(f => f[name].toLowerCase() == value.toLowerCase())
                if (!exists) {
                  let obj = {}
                  obj[name] = value
                  this.otherCommonInitField(obj)
                  this.table.push(obj)
                }
              }
          }
        })
      }
      if (deleteNameWithValuesMap.size > 0) {
        deleteNameWithValuesMap.forEach((list, name) => {
          this.table.map((info, i) => {
            if (list.includes(info[name])) {
              this.$set(info, 'isDeleted', true)
            }
          })
        })
      }
    },
    /**
     * 规格组发生变化(添加或删除一组规格（规格名+规格值），清空所有sku信息，然后初始化SKU)
     * @param variantArr
     */
    vriantGroupChange(variantArr) {
      this.table = []
      /* this.table.map((itm, i) => {
        this.$set(itm,'isDeleted',true)
      }) */

      // let columns =  JSON.parse(JSON.stringify(this.tableColumn))
      // console.log(columns,'>>>')
      // 删除列
      this.tableColumn = this.tableColumn.filter(f => !this.variantWithValuesListMap.get(f))
      // columns = columns.filter(f => !this.variantWithValuesListMap.get(f))

      // 添加列
      const newColumns = variantArr.map(f => f['variantName'])
      for (let i = 0, len = newColumns.length; i < len; i++) {
        this.tableColumn.splice(2 + i, 0, newColumns[i])
      }
      console.log(this.tableColumn, '>>>after...')

      // 组合所有、生成SKU
      switch (variantArr.length) {
        case 1: {
          let oneGroupVariant = variantArr[0]
          for (const one of oneGroupVariant['tagArr']) {
            let obj = {}
            obj[oneGroupVariant['variantName']] = one
            this.otherCommonInitField(obj)
            this.table.push(obj)
          }
          console.log(this.table, 'table..')
        }
          break
        case 2: {
          let oneGroupVariant = variantArr[0]
          let twoGroupVariant = variantArr[1]
          for (const one of oneGroupVariant['tagArr']) {
            for (const two of twoGroupVariant['tagArr']) {
              let obj = {}
              obj[oneGroupVariant['variantName']] = one
              obj[twoGroupVariant['variantName']] = two
              this.otherCommonInitField(obj)
              this.table.push(obj)
            }
          }
        }
          break
        default: {
          let oneGroupVariant = variantArr[0]
          let twoGroupVariant = variantArr[1]
          let thireGroupVariant = variantArr[2]
          for (const one of oneGroupVariant['tagArr']) {
            for (const two of twoGroupVariant['tagArr']) {
              for (const third of thireGroupVariant['tagArr']) {
                let obj = {}
                obj[oneGroupVariant['variantName']] = one
                obj[twoGroupVariant['variantName']] = two
                obj[thireGroupVariant['variantName']] = third
                this.otherCommonInitField(obj)
                this.table.push(obj)
              }
            }
          }
        }
      }

      this.$nextTick(() => {
        // this.tableColumn = [...columns]
        // 解决表格错位
        this.$refs.table.doLayout()

        // console.log(this.tableColumn,'>>>after2...')

        // 在下一次 DOM 更新后获取焦点
      /*  const inputRef = this.$refs.inputRef[this.table.length - 1];
        inputRef.focus(); */
      })
    },
    otherCommonInitField(obj) {
      obj['Case'] = 1
      obj['status'] = '1'
      obj['Weight(g)'] = 0
      obj['isDeleted'] = false
      obj['showStatusSelect'] = true
      // FOB Price\Cost Price\Procurement Price\\Wholesale Settlement Price\Retail Price
      obj['FOB Price($)'] = 0
      obj['Cost Price($)'] = 0
      obj['Wholesale Price($)'] = 0
      obj['Procurement Price($)'] = 0
      obj['Wholesale Settlement Price($)'] = 0
      obj['Retail Price($)'] = 0
      obj['length'] = ''
      obj['width'] = ''
      obj['height'] = ''
      obj['Inventory'] = ''
    },

    /**
     * 判断规格是否发生变化
     * @param variantArr
     */
    loadVariantIsChange(variantArr) {
      let isChanged = false
      let isNameChanged = false
      let addNameWithValuesMap = new Map()
      let deleteNameWithValuesMap = new Map()

      variantArr.forEach(varFor => {
        let variantNameFor = varFor['variantName']
        let variantValueArrFor = varFor['tagArr']

        let isEq = false
        let isNameEq = false

        this.variantWithValuesListMap.forEach((list, variantName) => {
          if (variantNameFor.toLowerCase() === variantName.toLowerCase()) {
            isEq = true
            isNameEq = true

            // 说明添加了新增特征
            for (const variantValueObj of variantValueArrFor) {
              let tagEq = false
              for (const listElementElement of list) {
                if (variantValueObj.toLowerCase() == listElementElement.toLowerCase()) {
                  tagEq = true
                }
              }
              // 标签值不相等
              if (!tagEq) {
                isEq = false
                let values = addNameWithValuesMap.get(variantNameFor)
                if (!values) {
                  values = []
                  addNameWithValuesMap.set(variantNameFor, values)
                }
                values.push(variantValueObj)
              }
            }

            // 减少了特征
            for (const listElementElement of list) {
              let tagEq = false
              for (const variantValueObj of variantValueArrFor) {
                if (variantValueObj.toLowerCase() == listElementElement.toLowerCase()) {
                  tagEq = true
                }
              }
              // 标签值不相等
              if (!tagEq) {
                isEq = false
                let values = deleteNameWithValuesMap.get(variantNameFor)
                if (!values) {
                  values = []
                  deleteNameWithValuesMap.set(variantNameFor, values)
                }
                values.push(listElementElement)
              }
            }
          }
        })

        // 发生过变化
        if (!isEq) {
          isChanged = true
        }
        // 名称发生过变化
        if (!isNameEq) {
          isNameChanged = true
        }
      })

      let obj = {
        isChanged: isChanged || (variantArr.length != this.variantWithValuesListMap.size), // 是否发生过改变，true发生过（包含规格名+值）
        isNameChanged: isNameChanged || (variantArr.length != this.variantWithValuesListMap.size), // 规格名称是否发生过变化
        addChangeValuesMap: addNameWithValuesMap, // 添加了规格值
        deleteNameWithValuesMap: deleteNameWithValuesMap, // 添加了规格值
        existsSkuDelete: false // 是否存在sku删除信息
      }

      // 没有发生过变化，判断是否SKU有删除，有删除，则认为有变化
      if (!obj['isChanged']) {
        // 组合的sku个数
        let combinationNum = 1
        variantArr.forEach(varFor => {
          combinationNum *= varFor['tagArr'].length
        })

        let len = this.table.length
        if (combinationNum !== len) {
          obj['isChanged'] = true
          obj['existsSkuDelete'] = true
        }
      }
      console.log(obj)

      return obj
    }

  }

}
</script>

<style lang="less" scoped>
@import "../../styles/spu.less";
</style>
<!-- add by cpgu 2023/05/24 以下style不能放入到以上的.less文件中，不然不生效，主要是scoped导致 begin  -->
<style lang="less">
.confirm-btn{
  background: #262B2F !important;
  color: #FFFFFF !important;
  border-color:#262B2F !important;
}
.cancel-btn:hover,.cancel-btn:active,.cancel-btn:focus{
  background:unset !important;
  color: unset !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/spuDetails/create-spu.vue